
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { Button } from '@/components/ui/button';
import { InfoIcon, Shield } from 'lucide-react';
import { Link } from "react-router-dom";

const MedicationInfoDialog: React.FC = () => {
  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button 
          variant="ghost" 
          size="sm" 
          className="h-8 w-8 p-0 rounded-full"
          onClick={(e) => e.stopPropagation()}
        >
          <InfoIcon className="h-4 w-4" />
          <span className="sr-only">Medication Information</span>
        </Button>
      </DialogTrigger>
      <DialogContent 
        className="sm:max-w-md max-h-[80vh] overflow-y-auto" 
        onMouseDown={(e) => e.stopPropagation()}
        onClick={(e) => e.stopPropagation()}
      >
        {/* DialogTitle must be the first child of DialogContent for accessibility */}
        <DialogTitle 
          id="medication-info-dialog-title"
          data-radix-dialog-title
          className="text-lg font-semibold"
        >
          Important Medication Information
        </DialogTitle>
        
        <DialogHeader>
          <DialogDescription>
            What you need to know about using our medication tracking
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-6 py-4 text-blue-800">
          <p>
            We're here to help you stay organized and on track with your
            medications.
          </p>

          <div className="space-y-2">
            <p className="font-medium">Three things to know:</p>
            <ol className="list-decimal list-inside space-y-1 text-sm">
              <li>
                Keep your prescriptions handy - they're our source of
                truth
              </li>
              <li>
                Your healthcare team guides your medical decisions
              </li>
              <li>Your information stays private and secure</li>
            </ol>
          </div>

          <p>Ready to start organizing your medications together? 💫</p>

          <div className="flex flex-wrap gap-3 pt-2">
            <Button
              variant="outline"
              size="sm"
              className="flex items-center gap-2"
              asChild
            >
              <Link to="/legal/disclaimer">
                <Shield className="w-4 h-4" />
                Learn More About Privacy & Security
              </Link>
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default MedicationInfoDialog;
